import React, { useState } from "react";

export default function DirectoryOverlay({ points, onClose }) {
  const [search, setSearch] = useState("");

  // Filter articles based on search input
  const filteredPoints = points.filter(
    (p) =>
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.author.toLowerCase().includes(search.toLowerCase()) ||
      p.location.toLowerCase().includes(search.toLowerCase()) ||
      (p.continent && p.continent.toLowerCase().includes(search.toLowerCase()))
  );

  // Group by continent
  const grouped = filteredPoints.reduce((acc, curr) => {
    if (!acc[curr.continent]) acc[curr.continent] = [];
    acc[curr.continent].push(curr);
    return acc;
  }, {});

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      overflowY: "auto",
      padding: "20px",
      zIndex: 999,
    }}>
      <button onClick={onClose} style={{
        position: "fixed",
    top: "20px",
    right: "20px",
    padding: "0",                  // remove extra padding
    margin: "0",
    cursor: "pointer",
    background: "none",            // remove background
    border: "none",                // remove border
    color: "white",                // make the X white
    fontSize: "1.5rem",            // adjust size if needed
    lineHeight: "1", 
      }}>✕</button>

      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
  <input
    type="text"
    placeholder="Search..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={{
      width: "20%",
      padding: "12px",
      fontSize: "1rem",
      border: "1px solid #ccc",
      outline: "none",
      color: "#fff",            // make text visible
      background: "transparent",       // optional: white background
    }}
  />

  

</div>
      <div style={{ width: "50%", padding: "20px", boxSizing: "border-box", margin: "0 auto" }}>
  {Object.entries(grouped).map(([continent, articles]) => (
    <div
      key={continent}
      style={{
        marginBottom: "40px",            // space after each continent
        borderBottom: "2px solid white", // thick line between continents
        paddingBottom: "20px",
      }}
    >
      <h2 style={{ color: "rgba(255, 255, 255, 1)", fontSize: "1.5rem", marginBottom: "15px" }}>
        {continent}
      </h2>

      {articles.map((article, index) => (
              
          <div
          key={article.article}
          style={{
            display: "flex",                       // new: make video and text side by side
            gap: "15px", // spacing between articles
            marginBottom: index < articles.length - 1 ? "20px" : "0",   
            borderBottom: index < articles.length - 1 ? "1px solid rgba(255,255,255,0.3)" : "none", // thin line
            paddingBottom: "10px",
          }}
        >
{/\.(mp4|mov|webm)$/i.test(article.preview) && (
      <video
        src={article.preview}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "120px",
          height: "80px",
          objectFit: "cover",
          flexShrink: 0,
        }}
      />
    )}


          <a href={article.article} style={{ color: "#fff", textDecoration: "none", fontSize: "1rem" }}>
            <p style={{ fontSize: "0.5rem", opacity: 0.8, margin: "0 0 3px 0" }}>{article.location}</p>
            <h3 style={{ margin: "0 0 3px 0", opacity: 1 }}>{article.name}</h3>
            <p style={{ fontSize: "0.5rem", opacity: 0.8, margin: "0 0 3px 0" }}>{article.author}</p>
            <p style={{ fontSize: "0.75rem", opacity: 1, margin: 0, fontFamily: "Georgia" }}>{article.sell}</p>
          </a>
        </div>
      ))}
    </div>
  ))}
</div>
    </div>
  );
}
